import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {startCourseAPI} from "../Services/api";
import LoadingSpinner from "../Components/LoadingSpinner/LoadingSpinner";
import {getAccessToken} from "../Services/auth";
import {saveStartedCourse} from "../Utils/Course/startedCourses";

// Courses created before this date load from CDN directly (preserving existing localStorage progress).
// Courses created from this date onward go through the proxy (with per-version localStorage isolation).
const PROXY_CUTOFF_DATE = new Date('2026-04-09');

const BASE_API = process.env.REACT_APP_BASE_CLIENT;
const COURSEWARE_BASE = process.env.NODE_ENV === 'development' ? '' : BASE_API.replace(/\/+$/, '');

export const Course = () => {
    const {signDocId} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [course, setCourse] = useState(null);

    /**
     * Starts the course and saves the opened version, so completion goes to this version
     * even when the course package sends the ID of an older version.
     * @returns {Promise<void>}
     */
    const init = async () => {
        try {
            const course = await startCourseAPI({signDocId});
            saveStartedCourse({signDoc: course});
            setCourse(course);
            setIsLoading(false);
        } catch (err) {
            console.error('[Course] init error:', err);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        init()
    }, []);


    if(isLoading){
        return <LoadingSpinner/>
    }

    // Old courses → CDN directly (no proxy, preserves existing progress)
    // New courses → proxy (localStorage isolation per version)
    const useProxy = course && new Date(course.createdAt) >= PROXY_CUTOFF_DATE;
    const iframeSrc = course
        ? (useProxy ? `${COURSEWARE_BASE}/courseware/${signDocId}/story.html?token=${encodeURIComponent(getAccessToken().replace('Bearer ', ''))}` : course.courseLink)
        : '';

    return <iframe
        src={iframeSrc}
        style={{height: '100vh', width: '100vw', border: 'none'}}
        title="Scorm Package URL"
    />
}
